// extracted by mini-css-extract-plugin
module.exports =  {"Resizer__Handle":"u3z5NSivR8KPhihw45iA","mobile":"sdERvx_vRSV6l5GWrfz7","theater":"WpUCte2fQCrDqeeTO4ey"};